import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withStyleSheet } from 'hoc/styles';
import { Autocomplete } from 'components/Autocomplete';
import { styleSheet } from './stylesheet';

class WatchlistAutocomplete extends PureComponent {
    static propTypes = {
        autoFocus: PropTypes.bool.isRequired,
        initialSearchTerm: PropTypes.string,
        name: PropTypes.string.isRequired,
        multi: PropTypes.bool,
        onChange: PropTypes.func.isRequired,
        options: PropTypes.arrayOf(PropTypes.any).isRequired,
        passedStyles: PropTypes.objectOf(PropTypes.any),
        placeholder: PropTypes.string.isRequired,
        styles: PropTypes.objectOf(PropTypes.object).isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)])
    };

    static defaultProps = {
        initialSearchTerm: null,
        multi: false,
        passedStyles: {},
        value: null
    };

    render() {
        const {
            autoFocus,
            initialSearchTerm,
            multi,
            styles,
            passedStyles,
            name,
            options,
            placeholder,
            onChange,
            value
        } = this.props;
        return (
            <Autocomplete
                autoFocus={autoFocus}
                clearOnSelect
                icon="list02"
                initialSearchTerm={initialSearchTerm}
                menuStyles={styles.menu}
                multi={multi}
                name={name}
                onChange={onChange}
                options={options}
                placeholder={placeholder}
                styles={{ ...styles.container, ...passedStyles }}
                value={value}
            />
        );
    }
}

export const WatchlistAutocompleteUI = compose(withStyleSheet(styleSheet))(WatchlistAutocomplete);
